const VALID = ["phone", "email"];
export const DEFAULT_OTP_CHANNELS = ["phone", "email"];
export function resolveOtpChannels(raw) {
    if (raw === undefined || raw === null)
        return [...DEFAULT_OTP_CHANNELS];
    if (!Array.isArray(raw)) {
        console.warn(`[Medos] otpChannels must be an array of "phone" | "email"; got ${typeof raw}. Falling back to ["phone"].`);
        return ["phone"];
    }
    const seen = new Set();
    for (const value of raw) {
        if (VALID.includes(value)) {
            seen.add(value);
        }
        else {
            console.warn(`[Medos] Unknown otpChannels entry ${JSON.stringify(value)}; expected "phone" or "email". Ignoring it.`);
        }
    }
    if (seen.size === 0) {
        console.warn('[Medos] otpChannels had no usable entries; using ["phone"].');
        return ["phone"];
    }
    return VALID.filter((channel) => seen.has(channel));
}
